// extracted by mini-css-extract-plugin
export default {"navLink":"NavLink_navLink__y1dSU","active":"NavLink_active__gDElP"};